import { Component, Input, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from "@angular/forms";
import { FormService } from "../../utils/form.service";
import { AppService } from "../../utils/app.service";
import { ApiService } from '../../utils/api.service';
import { StateService } from '@uirouter/angular';
import { TokenCookieService } from '../../utils/token-cookie.service';
@Component({
    selector: 'ss-business-add',
    template: require('./business-add.html'),
})

export class BusinessAddComponent implements OnInit {
    addBusinessForm = {
        business_owners: [
            {
                address: {
                    country: "US"
                },
                first_name: "",
                last_name: "",
                ownership: 100
            }
        ],
        address: {
            country: "US"
        },
        name: "",
        business_type: "",
        form_state: "",
        industry: "",

        form: new FormGroup({})
    };
    submittingBusiness = false;
    loadingCurrentUser = true;
    @Input() config;

    constructor(
        private app: AppService,
        private formService: FormService,
        private apiService: ApiService,
        private stateService: StateService,
        private formBuilder: FormBuilder,
        private tokenCookieService: TokenCookieService
    ) {
        this.addBusinessForm.form = formBuilder.group({
            businessName: [null, [Validators.required]],
            businessFormationState: ['', [Validators.required]],
            businessType: ['', [Validators.required]],
            businessIndustry: ['', [Validators.required]],
            businessOwnership: [100, [Validators.required]]
        })
    }

    onBusinessSelect(res) {
        this.submittingBusiness = true;
        this.app.connectSelectedBusinessToSS({ business_id: res });
    };

    handleError(err) {
        this.stateService.go('ss_landing_state', { error: err.message })
    }

    addBusiness(event) {
        this.formService.submit(
            this.addBusinessForm,
            this.apiService.addBusiness.bind(this.apiService),
            this.onBusinessSelect.bind(this),
            this.handleError(this),
            null,
            null
        );
    }

    ngOnInit() {
        this.apiService.getBusinesses().then((res: any) => {
            let businesses = res.filter(item => item.account.account_type == 'business' && item.business)
            if (businesses.length) {
                this.stateService.go('ss_select_business');
            } else {
                this.apiService.getCurrentUser().then((user: any) => {
                    this.addBusinessForm.business_owners[0].first_name = user.first_name;
                    this.addBusinessForm.business_owners[0].last_name = user.last_name;
                    this.tokenCookieService.setTokenCookie();
                    this.loadingCurrentUser = false;
                }).catch(err => {
                    this.stateService.go('ss_landing_state');
                })
            }
        }).catch(err => this.stateService.go('login_ss'))
    };
}
